<template>
  <div class="home padding80">
    <Header :current="0"></Header>



    <div class="banner">
      <img src="../assets/banner01.png" />
    </div>

    <div class="home-list">
      <div class="home-item even">
        <div class="layout">
          <div class="home-title left">
            <h2 class="title">产品及解决方案</h2>
            <div class="words">
              <p>以数字化、移动化、人工智能的技术方式，构建专业化IT解决方案、场景化商业生态服务。</p>
            </div>
          </div>

          <div class="home-tab mg40">
            <span class="item0" :class="tabVideo == '0' ?'active':''" @click="tabVideoFn(0)">科技外包服务</span>
            <span class="item" :class="tabVideo == '1' ?'active':''" @click="tabVideoFn(1)">产品运营服务</span>
            <span class="item" :class="tabVideo == '2' ?'active':''" @click="tabVideoFn(2)">IT解决方案</span>

          </div>
          <div class="home-prodect" v-if="tabVideo == '0' ">
            <div class="txt">
              <h3 class="pro-title">专业的IT团队</h3>
              <div class="dec">
                <p>充足的人力资源池，快速响应人员需求。全面的技术能力，包括：需求分析、前后端开发、数据、测试等，团队成熟、专业、高效。</p>
          
              </div>
              <!-- <div class="pro-btn" @click="gotoProduct(0,2)">了解更多</div> -->
            </div>
            <div class="img">
              <img src="../assets/人力资源服务.png" />
            </div>
          </div>

          <div class="home-prodect" v-if="tabVideo == '1'">
            <div class="img">
              <img src="../assets/商业运营.png" />
            </div>
            <div class="txt">
              <h3 class="pro-title">商业生态与金融场景的完美融合</h3>
              <div class="dec">深入理解商业生态运行模式、充足的行业资源、专业化的金融运营团队，为您打造全新的商业模式。</div>
              <!-- <div class="pro-btn" @click="gotoProduct(1,2)">了解更多</div> -->
            </div>
          </div>

          <div class="home-prodect" v-if="tabVideo == '2'">
            <div class="txt">
              <h3 class="pro-title">资深专家团队</h3>
              <div
                class="dec"
              >致力于为行业客户、泛金融机构提供一站式金融科技解决方案。。</div>
              <!-- <div class="pro-btn" @click="gotoProduct(2,2)">了解更多</div> -->
            </div>
            <div class="img">
              <img src="../assets/IT解决方案.png" />
            </div>
          </div>

        </div>
      </div>


    </div>

    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: "home",
  mounted() {
    // chrome 回到顶部
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
    // safari
    window.pageYOffset = 0;
    this.runInv();
  },

  data() {
    return {
      tabActive: 0,
      tabVideo: 0,
      dataList: [
        "https://i1.mifile.cn/a4/xmad_15535933141925_ulkYv.jpg",
        "https://i1.mifile.cn/a4/xmad_15532384207972_iJXSx.jpg",
        "https://i1.mifile.cn/a4/xmad_15517939170939_oiXCK.jpg"
      ],
      currentIndex: 0, //默认显示图片
      timer: null //定时器
    };
  },
  methods: {
    tabActiveFn(index) {
      this.tabActive = index;
    },
    tabVideoFn(index) {
      this.tabVideo = index;
    },
    gotoProduct(index, type) {
      this.$router.push({
        name: "product",
        params: {
          current: index,
          type: type
        }
      });
    },

    //轮播图切换
    gotoPage(index) {
      this.currentIndex = index;
    },
    //定时器
    runInv() {
      this.timer = setInterval(() => {
        this.gotoPage(this.nextIndex);
      }, 3000);
    }
  },
  computed: {
    //上一张
    prevIndex() {
      if (this.currentIndex == 0) {
        return this.dataList.length - 1;
      } else {
        return this.currentIndex - 1;
      }
    },
    //下一张
    nextIndex() {
      if (this.currentIndex == this.dataList.length - 1) {
        return 0;
      } else {
        return this.currentIndex + 1;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.home-list {
  width: 100%;
  color: #212121;
}
.home-item {
  padding-top: 97px;
  &.even {
    background-color: #fff;
  }
  &.odd {
    background-color: #f9f9f7;
  }
  &:nth-last-child(1) {
    padding-bottom: 90px;
  }
}
.home-title {
  line-height: 1.5;
  text-align: center;

  .title {
    margin-bottom: 40px;
    font-weight: 700;
    font-size: 28px;
    line-height: 1;
  }
  .words {
    padding: 0 50px;
    font-size: 18px;
  }
  &.left {
    .words {
      text-align: left;
      text-indent: 2em;
    }
  }
}
.home-prodect {
  padding: 50px 10px;
  overflow: hidden;
  .txt {
    float: left;
    padding-top: 55px;
    width: 475px;
    margin-right: 100px;
  }
  .pro-title {
    margin-bottom: 15px;
    font-size: 24px;
  }
  .dec {
    font-size: 16px;
    line-height: 1.6;
    p {
      margin-bottom: 15px;
    }
  }
  .pro-btn {
    margin-top: 50px;
    width: 160px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    background-color: #6bb945;
    border-radius: 50px;
    cursor: pointer;
  }
  .img {
    float: left;
    margin-right: 34px;
    width: 570px;
    height: 380px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.home-tab {
  margin-top: 40px;
  padding: 20px;
  text-align: center;
  font-size: 18px;
  color: #999;
  .item {
    display: inline-block;
    position: relative;
    cursor: pointer;
    &.active {
      color: #121212;
      font-weight: 700;
      &:after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -3px;
        height: 3px;
        background-color: #3f3f3f;
      }
    }
  }
  .item0 {
    display: inline-block;
    position: relative;
    cursor: pointer;
    &.active {
      color: #121212;
      font-weight: 700;
      &:after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -3px;
        height: 3px;
        background-color: #3f3f3f;
      }
    }
  }
  &.mg60 {
    .item {
      margin: 0 65px;
    }
  }
  &.mg40 {
    .item {
      margin: 0 30px 0 42px;
    }
    .item0 {
      margin:0 30px 0 0px;
    }
  }
}
.home-pro-list {
  padding: 40px 100px;
  .item {
    padding: 14px 15px 0 18px;
    width: 184px;
    height: 254px;
    background-color: #fff;
    box-shadow: 0 4px 20px 0 rgba(33, 33, 33, 0.1);
    border-radius: 6px;
  }
  img {
    margin: 14px auto;
    width: 50px;
    height: 50px;
  }
  .name {
    margin-bottom: 25px;
    font-size: 18px;
    color: #212121;
    text-align: center;
  }
  .txt {
    font-size: 14px;
    color: #999;
    line-height: 1.4;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
  opacity: 0;
}
</style>
